import React, { Component } from 'react'

// ui
import Modal from '../../components/feedback/modal'
import Button from '../../components/uielements/button'
import { Form, Input, Switch, Select, Upload } from 'antd'

import { FaCheck, FaTimes, FaPlus, FaSave } from 'react-icons/fa'

// redux
import { connect } from 'react-redux'
import userActions from '../../redux/user/actions'

class ResetPasswordForm extends Component {
    // update new Props
    componentWillReceiveProps(nextProps) {
        if (nextProps.newPassword !== this.props.newPassword) {
            const { form, newPassword } = nextProps
            form.setFieldsValue({ password: newPassword })
        }
    }

    componentDidMount() {
        const { form, newPassword } = this.props
        form.setFieldsValue({ password: newPassword })
    }

    // validate
    validatePassword = (rule, value, callback) => {
        const { form } = this.props

        if (value && value === '') callback('Xin mời bạn nhập mật khẩu')
        if (value && value.length < 6)
            callback('Độ dài tối thiểu của mật khẩu là 6')

        callback()
    }

    // event
    _onSubmit = e => {
        e.preventDefault()
        this.props.form.validateFields((err, values) => {
            if (!err) {
                const {user, newPassword} = this.props
                this.props.resetPassword(user.user_name, newPassword)
                this.props.onOk()
            }
        })
    }

    render() {
        const { getFieldDecorator } = this.props.form
        const { updateNewPassword } = this.props

        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 8 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 16 },
            },
        }

        return (
            <Form {...formItemLayout} onSubmit={this._onSubmit}>
                <Form.Item label="Mật khẩu" hasFeedback>
                    {getFieldDecorator('password', {
                        rules: [
                            {
                                required: true,
                                message: 'Xin mời nhập mật khẩu',
                            },
                            {
                                validator: this.validatePassword,
                            },
                        ],
                    })(
                        <Input.Password
                            onChange={e =>
                                updateNewPassword(
                                    e.target.value,
                                )
                            }
                        />
                    )}
                </Form.Item>
                <Form.Item wrapperCol={{ span: 19, offset: 8 }}>
                    <Button
                        size="large"
                        htmlType="submit"
                        style={{
                            backgroundColor: 'lightgreen',
                            marginRight: 5,
                            color: 'black',
                        }}
                    >
                        <FaSave style={{ marginRight: 5 }} />
                        Đặt lại mật khẩu
                    </Button>

                    <Button
                        size="large"
                        onClick={() => this.props.onCancel()}
                        style={{ backgroundColor: ' #ffcccc', color: 'black' }}
                    >
                        <FaTimes style={{ marginRight: 5 }} />
                        Huỷ
                    </Button>
                </Form.Item>
            </Form>
        )
    }
}

const mapStateToProps = state => {
    return {
        visible: state.user.modalResetPasswordState,
        user: state.user.currentUser,
        newPassword: state.user.newPassword
    }
}

const mapDispatchToResetFormProps = dispatch => {
    return {
        resetPassword: (user, newPassword) => {
            dispatch(userActions.action.resetPasswordUser(user, newPassword))
        },
        updateNewPassword: password => {
            dispatch(userActions.action.updateState({ newPassword: password }))
        }
    }
}

const WrappedResetPasswordForm = Form.create({ name: 'reset_password' })(ResetPasswordForm)
const ResetPasswordFinalForm = connect(mapStateToProps, mapDispatchToResetFormProps)(WrappedResetPasswordForm)

class ModalResetPassword extends Component {
    _handleOk = () => {
        this.props.dismiss()
    }

    _handleCancel = () => {
        this.props.dismiss()
    }

    render() {
        const { visible } = this.props

        return (
            <Modal
                visible={visible}
                title="Đặt lại mật khẩu"
                onOk={() => this._handleOK()}
                onCancel={() => this._handleCancel()}
                centered
                footer={[]}
            >
                <ResetPasswordFinalForm onCancel={() =>  this._handleCancel()} onOk={() => this._handleOk()} />
            </Modal>
        )
    }
}

const mapDispatchToProps = dispatch => {
    return {
        dismiss: () => {
            dispatch(userActions.action.dismissModalResetPassword())
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalResetPassword)